module.exports = __webpack_public_path__ + "img/59.03a872c.jpg";